import { Station, toDateTimeStr } from '@mi-front/core';
import moment from 'moment';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '../../../../../../core/hooks';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { NoMatchesReportForm } from './form';
import { NoMatchesReportResult } from './result';
import { AudiosWithoutMatchesReport } from './types';

export function AuditNoMatchesReportView(p: { station: Station }) {
  const tz = useTimezone();

  const from = toDateTimeStr(moment().tz(tz).subtract(1, 'week').startOf('day'), true);
  const to = toDateTimeStr(moment().tz(tz).endOf('day'), true);

  const resetValues = {
    audioFrom: from,
    audioTo: to,
    matchFrom: from,
    matchTo: to,
    useSameRange: true,
  };

  return (
    <ReportView<AudiosWithoutMatchesReport>
      defaultValues={resetValues}
      queryParamsTransform={{
        useSameRange: {
          parse: (val) => val !== 'false',
        },
      }}
      download={{
        filename: 'audios-without-matches',
        local: true,
        resultToExport: (result) =>
          result.items.map((item) => ({
            audio_id: item.audio.id,
            custom_id: item.audio.customId,
            created_at: item.audio.createdAt,
            same_md5_audio: item.sameMd5MatchedAudio?.customId,
          })),
      }}
      reportFn={(values) => {
        return apiClient.audit.stationReportsNoMatches({
          stationId: p.station.slug,
          audioFrom: values.audioFrom,
          audioTo: values.audioTo,
          matchFrom: values.useSameRange ? values.audioFrom : toDateTimeStr(values.matchFrom),
          matchTo: values.useSameRange ? values.audioTo : toDateTimeStr(values.matchTo),
        });
      }}
      Form={NoMatchesReportForm}
      Result={NoMatchesReportResult}
    />
  );
}
